import './style.css'

import React from 'react'

const NoteEditorPlaceholder = ({ size = 20 }) => {
  return (
    <div className="flexbox flexbox-align-center flexbox-centered shade-30 padding-huge">
      <svg
        className="note-editor-spinner "
        width={size}
        height={size}
        viewBox={'0 0 16 16'}
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C8.55228 0 9 0.447715 9 1C9 1.55228 8.55228 2 8 2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default NoteEditorPlaceholder
